import { withChatOnClick } from 'hoc';

import AmountAboveBalanceTransferLimitTooltip from './AmountAboveBalanceTransferLimitTooltip';

export default withChatOnClick(AmountAboveBalanceTransferLimitTooltip, 'openSupportChat');
